"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fiumalbo": {
    "09219b44": [{
      "hkey": "40aadfb8",
      "slug": "rotari-ronchi",
      "name": "Rotari-Ronchi",
      "primary": true,
      "skipSearch": false
    }],
    "rotari": [{
      "hkey": "40aadfb8",
      "slug": "rotari-ronchi",
      "name": "Rotari-Ronchi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ff2410e9": [{
      "hkey": "fa8814d0",
      "slug": "fiumalbo",
      "name": "Fiumalbo",
      "primary": true,
      "skipSearch": false
    }],
    "san-michele": [{
      "hkey": "fa8814d0",
      "slug": "fiumalbo",
      "name": "Fiumalbo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d7f784c5": [{
      "hkey": "fa8814d0",
      "slug": "fiumalbo",
      "name": "Fiumalbo",
      "primary": true,
      "skipSearch": false
    }],
    "versurone": [{
      "hkey": "fa8814d0",
      "slug": "fiumalbo",
      "name": "Fiumalbo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f32b287c": [{
      "hkey": "fa8814d0",
      "slug": "fiumalbo",
      "name": "Fiumalbo",
      "primary": true,
      "skipSearch": false
    }],
    "bivio-di-fiumalbo": [{
      "hkey": "fa8814d0",
      "slug": "fiumalbo",
      "name": "Fiumalbo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a03ac496": [{
      "hkey": "1fcb5880",
      "slug": "centro-dogana",
      "name": "Centro-Dogana",
      "primary": true,
      "skipSearch": false
    }],
    "dogana": [{
      "hkey": "1fcb5880",
      "slug": "centro-dogana",
      "name": "Centro-Dogana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "55a9868f": [{
      "hkey": "fa8814d0",
      "slug": "fiumalbo",
      "name": "Fiumalbo",
      "primary": true,
      "skipSearch": false
    }],
    "montalecchio": [{
      "hkey": "fa8814d0",
      "slug": "fiumalbo",
      "name": "Fiumalbo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;